import { createContext } from 'react';
import type {
  ILegalProvisionDeltaDetails,
  IReadLegalProvision,
} from '@raas/shared/src/types/legal-provision';
import type { IDeltaTranslation } from '@raas/shared/src/types/delta';

export interface IDeltaDataContext {
  baseDetails: IReadLegalProvision | null;
  setBaseDetails: (details: IReadLegalProvision | null) => void;
  compareDetails: IReadLegalProvision | null;
  setCompareDetails: (details: IReadLegalProvision | null) => void;
  deltaTranslations: IDeltaTranslation[] | null;
  currentDeltaTranslation: IDeltaTranslation | null;
  setCurrentDeltaTranslation: (details: IDeltaTranslation | null) => void;
  isLoadingDelta: boolean;
  delta: ILegalProvisionDeltaDetails | null;
  fetchDeltaDetails: () => Promise<void>;
}

const DeltaDataContext = createContext<IDeltaDataContext | undefined>(undefined);

export default DeltaDataContext;
